module.exports = __webpack_public_path__ + "img/clogo.e6106341.png";